import React, { useState, useEffect } from 'react';
import axiosInstance from '../../utils/axiosInstance';
import './AdminTasks.css';
import moment from 'moment-timezone';
import logo from '../../Assets/logo.jpg';

const AdminTasks = () => {
  const [form, setForm] = useState({
    name: '',
    coin: '',
    category: '',
    startTime: '',
    endTime: '',
    taskType: 'regular',
    targetDistance: '',
    locationRequirements: '',
    repeatDaily: false,
  });

  const [editId, setEditId] = useState(null);
  const [tasks, setTasks] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);
const [showAll, setShowAll] = useState(false);

  useEffect(() => {
    fetchTasks();
    fetchCategories();
  }, [showAll]);

  
  const fetchTasks = async () => {
  try {
    const url = showAll ? '/tasks' : '/tasks/latest';
    const res = await axiosInstance.get(url);
    setTasks(res.data.tasks);
  } catch (err) {
    console.error('Error fetching tasks', err);
  }
};

const renewAllTasks = async () => {
  if (!window.confirm('Renew ALL latest tasks?')) return;

  try {
    await axiosInstance.post('/tasks/renew-all-latest');
    alert('All tasks renewed successfully');

    // 🔄 Refresh list
setShowAll(false); // go back to Latest Tasks
fetchTasks();
  } catch (err) {
    console.error(err);
    alert('Bulk renew failed');
  }
};

  const fetchCategories = async () => {
    try {
      const res = await axiosInstance.get('/categories/all-parent');
      setCategories(res.data);
    } catch (err) {
      console.error('Error fetching categories', err);
    }
  };

  const handleChange = (e) => {
    const { name, value, type, checked, files } = e.target;
    if (type === 'checkbox') {
      setForm({ ...form, [name]: checked });
    } else if (files) {
      setForm({ ...form, image: files[0] });
    } else {
      setForm({ ...form, [name]: value });
    }
  };
const toggleStatus = async (task) => {
  const currentStatus = task.status || 'active';
  const newStatus = currentStatus === 'active' ? 'inactive' : 'active';

  try {
    await axiosInstance.put(`/tasks/${task._id}/status`, {
      status: newStatus,
    });

    fetchTasks();
  } catch (err) {
    console.error('Status toggle error', err);
    alert('❌ Failed to update status');
  }
};




  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const data = new FormData();
      Object.entries(form).forEach(([key, value]) => {
        if (value !== '' && value !== null && value !== undefined) data.append(key, value);
      });

      if (editId) {
        await axiosInstance.put(`/tasks/${editId}`, data);
        alert('✅ Task updated successfully');
      } else {
        await axiosInstance.post('/tasks', data);
        alert('✅ Task created successfully');
      }

      setForm({
        name: '',
        coin: '',
        category: '',
        startTime: '',
        endTime: '',
        taskType: 'regular',
        targetDistance: '',
        locationRequirements: '',
        repeatDaily: false,
      });
      setEditId(null);
      fetchTasks();
    } catch (err) {
      console.error('Task save error', err);
      alert('❌ Error saving task');
    }

    setLoading(false);
  };
const handleRenew = async (task) => {
  if (!window.confirm('Renew this task for next day?')) return;

  try {
    await axiosInstance.post(`/renewtasks/${task._id}`);
    alert('🔄 Task renewed for next day');
        setShowAll(false); // 👈 force latest view

    fetchTasks();
  } catch (err) {
    console.error('Renew error', err);
    alert('❌ Failed to renew task');
  }
};

  const handleEdit = (task) => {
    setForm({
      name: task.name,
      coin: task.coin,
      category: task.category?._id || '',
      startTime: task.startTime
        ? moment(task.startTime).tz('Asia/Kolkata').format('YYYY-MM-DDTHH:mm')
        : '',
      endTime: task.endTime
        ? moment(task.endTime).tz('Asia/Kolkata').format('YYYY-MM-DDTHH:mm')
        : '',
      taskType: task.taskType || 'regular',
      targetDistance: task.targetDistance || '',
      locationRequirements: task.locationRequirements || '',
      repeatDaily: task.repeatDaily || false,
    });
    setEditId(task._id);
    window.scrollTo(0, 0);
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Are you sure you want to delete this task?')) return;
    try {
      await axiosInstance.delete(`/tasks/${id}`);
      fetchTasks();
      alert('🗑️ Task deleted');
    } catch (err) {
      console.error('Delete error', err);
      alert('❌ Error deleting task');
    }
  };

  return (
    <div className="admin-container">
      <h2 className="admin-heading">{editId ? 'Edit Task' : 'Create Task'}</h2>

      <form onSubmit={handleSubmit} className="task-form">
        <input
          name="name"
          placeholder="Task Name"
          value={form.name}
          onChange={handleChange}
          required
          className="form-input"
        />
        <input
          name="coin"
          type="number"
          placeholder="Coins"
          value={form.coin}
          onChange={handleChange}
          required
          className="form-input"
        />

        <select
          name="category"
          value={form.category}
          onChange={handleChange}
          required
          className="form-input"
        >
          <option value="">Select Category</option>
          {categories.map(cat => (
            <option key={cat._id} value={cat._id}>{cat.name}</option>
          ))}
        </select>

        <select
          name="taskType"
          value={form.taskType}
          onChange={handleChange}
          className="form-input"
        >
          <option value="regular">Regular</option>
          <option value="location">Location</option>
        </select>

        {/* Start/End Time for all tasks */}
        <input
          name="startTime"
          type="datetime-local"
          value={form.startTime}
          onChange={handleChange}
          required
          className="form-input"
        />
        <input
          name="endTime"
          type="datetime-local"
          value={form.endTime}
          onChange={handleChange}
          required
          className="form-input"
        />

        {/* Location-specific fields */}
        {form.taskType === 'location' && (
          <>
            <input
              name="targetDistance"
              type="number"
              placeholder="Target Distance (meters)"
              value={form.targetDistance}
              onChange={handleChange}
              className="form-input"
            />
            <textarea
              name="locationRequirements"
              placeholder="Location Requirements"
              value={form.locationRequirements}
              onChange={handleChange}
              className="form-input"
            />
          </>
        )}

        

        <button type="submit" disabled={loading} className="submit-btn">
          {loading ? (editId ? 'Updating...' : 'Creating...') : (editId ? 'Update Task' : 'Create Task')}
        </button>
      </form>


      <h2 className="admin-heading">All Tasks</h2>
      <div className="see-more-wrapper">
  <button
    className="see-more-btn"
    onClick={() => setShowAll(!showAll)}
  >
    {showAll ? 'Show Latest Tasks' : 'See More'}
  </button>
  <button onClick={renewAllTasks}>
  Renew All Tasks
</button>

</div>

      <div className="table-wrapper">
        
        <table className="task-table">
          <thead>
            <tr>
              <th>Name</th>
              <th>Coin</th>
              <th>Type</th>
              <th>Category</th>
              <th>Start</th>
              <th>End</th>
              <th>Distance</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {tasks.map(task => (
              <tr key={task._id}>
                <td>{task.name}</td>
                <td>
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                    <img
                      src={logo}
                      alt="coin"
                      style={{
                        width: "18px",
                        height: "18px",
                        borderRadius: "50%",
                        marginRight: "4px",
                        boxShadow: "0 1px 2px rgba(0, 0, 0, 0.25)",
                        objectFit: "cover",
                      }}
                    />
                    <span>{task.coin}</span>
                  </div>
                </td>
                <td>{task.taskType}</td>
                <td>{task.category?.name || '-'}</td>
                <td>{task.startTime ? new Date(task.startTime).toLocaleString() : '-'}</td>
                <td>{task.endTime ? new Date(task.endTime).toLocaleString() : '-'}</td>
                <td>{task.targetDistance || '-'}</td>
                <td>
                  <button onClick={() => handleEdit(task)} className="edit-btn">Edit</button>
                   <button
    onClick={() => handleRenew(task)}
    className="renew-btn"
  >
    Renew
  </button>
<button
  className={`status-btn ${task.status === 'active' ? 'active' : 'inactive'}`}
  onClick={() => toggleStatus(task)}
>
  {task.status === 'active' ? 'Active' : 'Inactive'}
</button>

                  <button onClick={() => handleDelete(task._id)} className="delete-btn">Delete</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default AdminTasks;
